import script from "./selection-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./selection-menu.vue?vue&type=script&setup=true&lang=ts"

import "./selection-menu.vue?vue&type=style&index=0&id=1d783c08&lang=scss"

const __exports__ = script;

export default __exports__